import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const InformationIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M63.9999 9.33398C53.1879 9.33398 42.6187 12.5401 33.6288 18.547C24.6389 24.5538 17.6321 33.0916 13.4945 43.0806C9.35694 53.0696 8.27436 64.0613 10.3837 74.6656C12.493 85.2699 17.6995 95.0105 25.3448 102.656C32.99 110.301 42.7307 115.508 53.335 117.617C63.9393 119.726 74.9309 118.644 84.92 114.506C94.909 110.368 103.447 103.362 109.454 94.3718C115.46 85.3819 118.667 74.8127 118.667 64.0006C118.652 49.5065 112.888 35.61 102.64 25.3611C92.3906 15.1121 78.4941 9.3481 63.9999 9.33398ZM63.9999 34.3473C65.4073 34.3684 66.7493 34.945 67.7334 35.9515C68.7174 36.9579 69.2637 38.3125 69.2531 39.7201C69.2426 41.1276 68.676 42.4738 67.677 43.4654C66.678 44.457 65.3275 45.0134 63.9199 45.0134C62.5124 45.0134 61.1619 44.457 60.1629 43.4654C59.1639 42.4738 58.5973 41.1276 58.5868 39.7201C58.5762 38.3125 59.1225 36.9579 60.1065 35.9515C61.0906 34.945 62.4325 34.3684 63.8399 34.3473H63.9999ZM69.3333 92.1073C69.3333 93.5218 68.7714 94.8783 67.7712 95.8785C66.771 96.8787 65.4144 97.4407 63.9999 97.4407C62.5855 97.4407 61.2289 96.8787 60.2287 95.8785C59.2285 94.8783 58.6666 93.5218 58.6666 92.1073V58.3473C58.6666 56.9328 59.2285 55.5763 60.2287 54.5761C61.2289 53.5759 62.5855 53.014 63.9999 53.014C65.4144 53.014 66.771 53.5759 67.7712 54.5761C68.7714 55.5763 69.3333 56.9328 69.3333 58.3473V92.1073Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default InformationIcon;

InformationIcon.propTypes = customIconsPropTypes;
